export const WS_EVENT_MESSAGE = 'message';
export const WS_EVENT_CONNECT = 'connect';
export const WS_EVENT_AUTHENTICATE = 'authenticate';
export const WS_PAYMENT_UPDATES = 'payments:updates';
